// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1nV3A","row":"styles_row__1p6r7"};